export default __webpack_public_path__ + "static/media/zori_xl.6aa33030.jpg";